import axiosInstance from 'services/axios/axios';
import { addMessage } from 'store/ancillary/actions';
import { setSession } from '../../../../store/utility';
import { ERROR_MESSAGE_IMPERSONATOR, ERROR_MESSAGE_IMPERSONATOR_UNKNOWN } from './_constants';

export const getImpersonationData = async (identifier, dispatch) => {
	let userImpersonation = null;
	try {
		const impersonationProfile = await axiosInstance.get(
			'api/Identity/ImpersonationIdentity',
			{
				params: {
					impersonationId: identifier,
				},
			}
		);

		if (impersonationProfile && impersonationProfile.data) {
			userImpersonation = impersonationProfile.data.payload;
			userImpersonation.isDEVTeam =
				userImpersonation?.Roles?.findIndex(
					role => role.Full === 'DEV Team' || role.ID === 18
				) > -1;
			if (!!impersonationProfile.data.messages) {
				impersonationProfile.data.messages.forEach(message => {
					dispatch(addMessage(message));
				});
			}
		}

		if (userImpersonation === null) {
			dispatch(
				addMessage({
					Key: 3,
					Value: ERROR_MESSAGE_IMPERSONATOR_UNKNOWN,
				})
			);
		}
	} catch (error) {
		dispatch(
			addMessage({
				Key: 3,
				Value: ERROR_MESSAGE_IMPERSONATOR,
			})
		);
	}

	return userImpersonation;
};

/**
 * Retrieves metadata of impersonation target and sets relevant session variables to perform impersonation.
 *
 * @param {Object[]} arrCells array of impersonation target table metadata objects.
 * @returns void
 */
export const setImpersonationSession = async arrCells => {
	await trySetSession('LoggedOnESOType', 'F');
	await trySetSession(
		'ImpersonatorFESO',
		arrCells['Network_ID'].Value
			? arrCells['Network_ID'].Value
			: arrCells['UPMC_E-Sign-On_ID']
	);
};

/**
 * Resets relevant session variables according to metadata of logged-in user.
 *
 * @param {string} esoID ESO ID of logged-on user.
 * @returns void
 */
export const resetImpersonationSession = async esoID => {
	await trySetSession('LoggedOnESOType', 'F');
	await trySetSession('ImpersonatorFESO', '');
};

const trySetSession = async (key, value) => {
	const response = await setSession(key, value);
	if (!response.ok || response.redirected) {
		throw new Error(`Error occurred with status ${response.status}.`);
	}
};
